import styled from 'styled-components';

export const PageTitle = styled.h1`
    ${(props) => props.theme.typography.headingXL};
    margin: 0 auto 1.5rem 0;
	text-wrap: balance;
	max-width: 48rem;
`;